import React, { useState } from "react";
import "../FAQCard/FAQCard.css";
function FAQCard(props) {
  const [answer, setAnswer] = useState(0);
  const [btnIcon, setBtnIcon] = useState(1);

  const handleBtnClick = () => {
    setAnswer(!answer);
    setBtnIcon(!btnIcon);
  };

  return (
    <div className="faqCard">
      <h1 className="quesNo">{props.quesNo}</h1>
      <div className="quesBox">
        <h1 className="ques">{props.ques}</h1>
        <div className={answer ? "ans" : "ans-close"}>{props.ans}</div>
      </div>
      <div className="btnDiv">
        <button className="faqButton" onClick={handleBtnClick}>
          <div className={btnIcon ? "" : "btnRotate"}>+</div>
        </button>
      </div>
    </div>
  );
}
export default FAQCard;
